import React, { memo } from 'react';
import classNames from 'classnames';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Header');

const Header = ({ title, description, className, overrides }) => {
    const classes = useStyles();
    return (
        <div className={classNames(classes.root, className)}>
            <Text type="h6" {...overrides?.title}>
                {title}
            </Text>
            <Text type="body" {...overrides?.description}>
                {description}
            </Text>
        </div>
    );
};

export default memo(Header);
